import React, { Component } from "react";
import { TextArea } from "carbon-components-react";
import { connect } from "react-redux";
import { sdg1672Actions } from "../../../../../../_actions";
class Other extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  state = {};

  handleChange(e) {
    const { dispatch } = this.props;

    dispatch(sdg1672Actions.updateMetadataField(e.target.name, e.target.value));
  }
  render() {
    return (
      <React.Fragment>
        <div className="box-header with-border">
          <h3 className="box-title metadata-title">Other</h3>
        </div>
        <div className="box-body with-border">
          <div
            className="row"
            style={{ display: "flex", marginBottom: "15px" }}
          >
            <div className="col-sm-8 adaptive-form">
              <TextArea
                id="disaggregation_description"
                name="disaggregation_description"
                value={
                  this.props.data &&
                  this.props.data["disaggregation_description"]
                    ? this.props.data["disaggregation_description"]
                    : ""
                }
                onChange={this.handleChange}
                labelText="22. Please specify any information relevant to the disaggregation provided by sex, age group, education level, income or expenditure quintiles, disability status, and population group."
                style={{ marginBottom: "15px" }}
              />
              <TextArea
                id="other_notes"
                name="other_notes"
                value={
                  this.props.data && this.props.data["other_notes"]
                    ? this.props.data["other_notes"]
                    : ""
                }
                maxCount={1000}
                enableCounter
                onChange={this.handleChange}
                labelText="23. Other methodological notes / deviations from global metadata:"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1672State;

  return {
    data
  };
}

const connectedOther = connect(mapStateToProps)(Other);

export { connectedOther as Other };
